import { render, staticRenderFns } from "./assetTable.vue?vue&type=template&id=6b51241e&scoped=true"
import script from "./assetTable.vue?vue&type=script&lang=js"
export * from "./assetTable.vue?vue&type=script&lang=js"
import style0 from "./assetTable.vue?vue&type=style&index=0&id=6b51241e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51241e",
  null
  
)

export default component.exports